export enum ImageSlotType {
  Required = 'required',
  Optional = 'optional',
}
